module.exports = __webpack_public_path__ + "05c8f8839f1d5e5c4b8c79fd0ec99cc6.png";